import { Placement } from '@floating-ui/react';
import { useCallback, useContext } from 'react';
import { useRegisterTypeStrings } from '@/modules/common/hooks/useRegisterTypeStrings.tsx';
import { IssuerInviteShareholderModal } from '@/modules/issuer-dashboard/components/modals/IssuerInviteShareholderModal.tsx';
import { useIssuerRegisterClassMenuOptions } from '@/modules/issuer-dashboard/hooks/useIssuerRegisterClassMenuOptions.tsx';
import { Button, DropdownMenu, ModalProviderContext } from 'ui';
import { useIsMobile } from 'ui/hooks';
import { DotsHorizontalIcon, UsersAddGrayIcon } from 'ui/icons';
import { IssuerRegisterClassResponse } from 'api';

interface IssuerRegisterClassDropDownProps {
  registerClass: IssuerRegisterClassResponse;
  placement?: Placement;
}

const IssuerRegisterClassDropDown = ({
  registerClass,
  placement = 'left-start',
}: IssuerRegisterClassDropDownProps) => {
  const items = useIssuerRegisterClassMenuOptions(registerClass);
  const { openModal } = useContext(ModalProviderContext);
  const { isMobile } = useIsMobile();
  const getRegisterTypeStrings = useRegisterTypeStrings();

  const handleOpenInviteShareholderModal = useCallback(
    (item: IssuerRegisterClassResponse) => () => {
      const { class_name, id, register_obj, register_id, current_price_per_share } = item;
      openModal(IssuerInviteShareholderModal, {
        defaultRegisterClassOption: {
          label: class_name,
          value: { id, current_price_per_share, toString: () => class_name },
        },
        defaultRegisterOption: {
          label: register_obj?.name || 'register name',
          value: {
            id: register_id,
            toString: () => register_obj?.name || 'register name',
          },
        },
        disabledSubscription: current_price_per_share === 0,
      });
    },
    [openModal],
  );

  return (
    <div
      className="flex gap-6 items-center justify-end"
      onClick={e => {
        e.stopPropagation();
      }}
    >
      {isMobile ? (
        <span onClick={handleOpenInviteShareholderModal(registerClass)}>
          <img
            alt="Add holders"
            src={UsersAddGrayIcon}
            className="cursor-pointer hover:opacity-70 min-w-[24px] min-h-[24px]"
          />
        </span>
      ) : (
        <Button
          className="w-[145px] px-0 py-0 min-h-8"
          variant="secondary"
          onClick={handleOpenInviteShareholderModal(registerClass)}
        >
          <span className="capitalize">{getRegisterTypeStrings('application')}</span>
          &nbsp;link
        </Button>
      )}

      <DropdownMenu
        items={items}
        button={
          <button className="flex items-center justify-center">
            <img
              alt="More..."
              src={DotsHorizontalIcon}
              className="cursor-pointer hover:opacity-70 min-w-[24px] min-h-[24px]"
            />
          </button>
        }
        placement={placement}
        className="w-[180px]"
        containerClassName="max-w-6"
      />
    </div>
  );
};

export default IssuerRegisterClassDropDown;
